import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ShortObject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-json-object';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  ClientNotificationService
} from 'projects/desktop/src/app/view/notification/client-nfs-page/data/client-nfs.service';
import { TasksService } from 'projects/desktop/src/app/modules/home-page/data/tasks/tasks.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReportsService } from 'projects/app-misc/src/app/modules/reports/data/reports.service';
import { ProjectService } from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import { ShortProject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-project';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-create-project-report-dialog',
  templateUrl: './create-project-report-dialog.component.html',
  styleUrls: ['./create-project-report-dialog.component.scss']
})
export class CreateProjectReportDialogComponent implements OnInit, OnDestroy {

  projs: ShortProject[];
  lastProjs: ShortProject[];
  selectedProj: ShortProject;
  loadingSpinner: boolean;

  id: number;
  type: string;

  searchProjSubj = new Subject<string>();


  constructor(
    private snackBar: MatSnackBar,
    private reportsService: ReportsService,
    private projectsService: ProjectService,
    protected dialogRef: MatDialogRef<CreateProjectReportDialogComponent>
  ) {
  }

  ngOnInit(): void {
    this.projectsService.getLastProjects().subscribe(projs => {
      this.projs = projs
      this.lastProjs = projs
    })

    this.subToSearch()
  }

  subToSearch() {
    this.searchProjSubj.pipe(debounceTime(500)).subscribe(query => {
      if(query === '') {
        this.projs = this.lastProjs
        return
      }
      this.projectsService.searchProjects(query).subscribe(projs => {
        this.projs = projs
      })
    })
  }

  createMessageButton() {
    this.loadingSpinner = true;

    this.reportsService.createProjectCostReport(this.selectedProj.id).subscribe(result => {
      this.loadingSpinner = false;
      this.dialogRef.close(['success', result]);
    }, error => {
      this.loadingSpinner = false;
      this.openSnackBar(error.message)
    })
  }

  openSnackBar(message: string, duration = 5000) {
    this.snackBar.open(message, '', {
      duration,
      panelClass: 'error-snackbar',
      verticalPosition: 'top',
    });
  }

  closeDialog() {
    this.dialogRef.close('close-button');
  }

  searchProjects() {
    let panel = document.getElementsByClassName('create-project-cost-report')[0]
    if(panel) {
      let input = panel.getElementsByClassName('p-inputtext')[0] as HTMLInputElement
      this.searchProjSubj.next(input.value)
    }
  }

  ngOnDestroy() {
    this.searchProjSubj.unsubscribe()
  }
}
